import { cloneElement } from 'react';
import { Box, useTheme } from '@mui/material';
import { IconBadgeTone } from '../../themes';

interface IIconBadgeProps {
  icon: React.ReactElement;
  tone: IconBadgeTone;
  size?: number;
}

// Quadrado de ícone com gradiente mesclado por tom (guia seções 23-25) —
// primary/cyan/success/error/warning/purple/neutral, lidos de theme.torq.iconBadge.
export const IconBadge: React.FC<IIconBadgeProps> = ({ icon, tone, size = 40 }) => {
  const theme = useTheme();
  const { gradient, border, iconColor } = theme.torq.iconBadge[tone];

  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '10px',
        background: gradient,
        border: `1px solid ${border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {cloneElement(icon, { sx: { fontSize: Math.round(size * 0.55), color: iconColor, ...(icon.props?.sx || {}) } })}
    </Box>
  );
};
